import { render } from "./MainFrame.vue?vue&type=template&id=24319cd4&scoped=true"
import script from "./MainFrame.vue?vue&type=script&lang=js"
export * from "./MainFrame.vue?vue&type=script&lang=js"

import "./MainFrame.vue?vue&type=style&index=0&id=24319cd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24319cd4"

export default script